import React, { useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";

export default function CheckPositionExist() {
  const [positionDoesNotExistInElastic, setPositionDoesNotExistInElastic] =
    useState([]);
  const [positionDoesNotExistInMySql, setPositionDoesNotExistInMySql] =
    useState([]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPositionsDoesNotExist = async () => {
    const headersRequest = getHeaderForRequest();
    let reportPosition;
    try {
      reportPosition = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/check-exist-position",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return reportPosition.data.data;
  };

  const checkPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const responseGetPositionsDoesNotExist =
      await sendRequestGetPositionsDoesNotExist();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!responseGetPositionsDoesNotExist) {
      return;
    }
    setPositionDoesNotExistInElastic(responseGetPositionsDoesNotExist.mysql);
    setPositionDoesNotExistInMySql(responseGetPositionsDoesNotExist.elastic);
  };

  const removePositionsDoNotExistInMySqlButExistInElastic = async (e) => {
    e.preventDefault();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    for (const key in positionDoesNotExistInMySql) {
      const positionTagHtml = positionDoesNotExistInMySql[key];
      await sendResponseRemovePositionsDoesNotExistInMySql(positionTagHtml);
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    checkPositions();
  };

  const sendResponseRemovePositionsDoesNotExistInMySql = async (
    positionTagHtmlID
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/elastic/" +
          positionTagHtmlID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const removePositionsDoNotExistInElasticButExistInMysql = async (e) => {
    e.preventDefault();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    for (const key in positionDoesNotExistInElastic) {
      const positionTagHtml = positionDoesNotExistInElastic[key];
      await sendResponseRemovePositionDoseNotExistInElastic(positionTagHtml);
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    checkPositions();
  };

  const sendResponseRemovePositionDoseNotExistInElastic = async (
    positionTagHtmlID
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/mysql/" +
          positionTagHtmlID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generatePositionDoesNotExistIDS = () => {
    return (
      <div>
        <div>
          <p className="pt-3">
            جایگاه هایی که در MySql موجود است اما در Elasticsearch موجود نیست.
            <button
              className="btn btn-danger"
              onClick={removePositionsDoNotExistInElasticButExistInMysql}
            >
              حذف گروهی این جایگاه ها
            </button>
          </p>
          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space table-hover">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره جایگاه</td>
                </tr>
              </thead>
              <tbody>
                {positionDoesNotExistInElastic.length == 0 ? (
                  <></>
                ) : (
                  <>
                    {positionDoesNotExistInElastic.map(
                      (positionDoesNotExistID, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{positionDoesNotExistID}</td>
                          </tr>
                        );
                      }
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <hr />
        <div>
          <p className="pt-3">
            جایگاه هایی که در Elasticsearch موجود است اما در MySql موجود نیست.
            <button
              className="btn btn-danger"
              onClick={removePositionsDoNotExistInMySqlButExistInElastic}
            >
              حذف گروهی این جایگاه ها
            </button>
          </p>
          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space table-hover">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره جایگاه</td>
                </tr>
              </thead>
              <tbody>
                {positionDoesNotExistInMySql.length == 0 ? (
                  <></>
                ) : (
                  <>
                    {positionDoesNotExistInMySql.map(
                      (positionDoesNotExistID, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{positionDoesNotExistID}</td>
                          </tr>
                        );
                      }
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="check-position"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  بررسی موجود بودن جایگاه ها
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    checkPositions();
                  }}
                  className="btn btn-success"
                >
                  بررسی جایگاه ها
                </button>
              </div>
              <div>{generatePositionDoesNotExistIDS()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
